export class ListFindingExclusionsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "FindingExclusionFilterConditions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListFindingExclusionsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
